var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",staticClass:"publish-title",class:`publish-title--${_vm.level}`},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]}),(_vm.multiple)?_c('span',{staticClass:"publish-title__meta"},[_vm._v(_vm._s(_vm.$t("adminFlows.multipleSelection")))]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }